import { FunctionComponent } from 'react';

// Components
import Paginate from 'react-paginate';

// Utilities
import classnames from 'classnames';

// Styles
import styles from './Pagination.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useRouter } from 'next/router';

interface PaginationProps {
    total: number;
    limit: number;

    pageClassName?: string;
    disabledClassName?: string;
    pageLinkClassName?: string;
    containerClassName?: string;

    breakClassName?: string;
    breakLinkClassName?: string;

    activeClassName?: string;
    activeLinkClassName?: string;

    nextClassName?: string;
    nextLinkClassName?: string;

    previousClassName?: string;
    previousLinkClassName?: string;
}

const Pagination: FunctionComponent<PaginationProps> = ({ total, limit, ...props }) => {
    const router = useRouter();
    const queryPage = Number(router.query.page || 1);
    const pageCount = Math.ceil(Number(total) / Number(limit));

    const handlePageChange = ({ selected = 0 }) => {
        const nextQueryPage = selected + 1;

        if (nextQueryPage !== queryPage) {
            router.push({
                pathname: router.pathname,
                query: {
                    ...router.query,
                    page: nextQueryPage,
                },
            });
        }
    };

    return (
        <Paginate
            pageCount={pageCount}
            pageRangeDisplayed={3}
            marginPagesDisplayed={3}
            forcePage={queryPage - 1}
            initialPage={queryPage - 1}
            onPageChange={handlePageChange}
            pageClassName={classnames([styles.page, props.pageClassName])}
            disabledClassName={classnames([styles.disabled, props.disabledClassName])}
            pageLinkClassName={classnames([styles.page_link, props.pageLinkClassName])}
            containerClassName={classnames([styles.container, props.containerClassName])}
            breakClassName={classnames([styles.break, props.breakClassName])}
            breakLinkClassName={classnames([styles.break_link, props.breakLinkClassName])}
            activeClassName={classnames([styles.active, props.activeClassName])}
            activeLinkClassName={classnames([styles.active_link, props.activeLinkClassName])}
            nextClassName={classnames([styles.next, props.nextClassName])}
            nextLinkClassName={classnames([styles.next_link, props.nextLinkClassName])}
            previousClassName={classnames([styles.previous, props.previousClassName])}
            previousLinkClassName={classnames([styles.previous_link, props.previousLinkClassName])}
            nextLabel={<FontAwesomeIcon icon={faChevronRight} className={styles.icon} />}
            previousLabel={<FontAwesomeIcon icon={faChevronLeft} className={styles.icon} />}
        />
    );
};

export default Pagination;
